import apiStore from '@/api/stores'

const state = {
  validationErrors: null,
  isSubmitting: false,
}

export const mutationTypes = {
  deleteStoreStart: '[delete store] delete Store Start',
  deleteStoreSuccess: '[delete store] delete Store Success',
  deleteStoreFailure: '[delete store] delete Store Failure',
}

export const actionType = {
  deleteStore: '[delete store] deleteStore',
}

const mutations = {
  [mutationTypes.deleteStoreStart](state) {
    state.isSubmitting = true
    state.validationErrors = null
  },

  [mutationTypes.deleteStoreSuccess](state) {
    state.isSubmitting = false
  },

  [mutationTypes.deleteStoreFailure](state, payload) {
    state.isSubmitting = false
    state.validationErrors = payload
  },
}

const actions = {
  [actionType.deleteStore](context, {id}) {
    context.commit(mutationTypes.deleteStoreStart)
    return new Promise((resolve) => {
      apiStore
        .deleteStore(id)
        .then((response) => {
          context.commit(mutationTypes.deleteStoreSuccess, response.data)
          resolve(response.data)
        })
        .catch((result) => {
          context.commit(
            mutationTypes.deleteStoreFailure,
            result.response.data.errors
          )
        })
    })
  },
}

export default {
  state,
  mutations,
  actions,
}
